
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { emptyToLine, splitThousands } from "@common/src/utils/common";
import { Table } from "@common/src/utils/decorator";
import ConfirmPaymentItem from "@/views/purchase/components/confirm-payment.vue";
import RegisterInvoice from "@/views/purchase/components/register-invoice.vue";
import ElImageViewer from "element-ui/packages/image/src/image-viewer.vue";
import t from "@common/src/i18n/t";
import dayjs from "dayjs";
const base = namespace("base");
const staff = namespace("staff");
const purchase = namespace("purchase");
const supplier = namespace("supplier");
const finance = namespace("finance");

@Component({
  components: { ConfirmPaymentItem, RegisterInvoice, ElImageViewer }
})
@Table("loadListData")
export default class ServiceList extends Vue {
  dayjs = dayjs;
  @base.Action getDictionaryList;
  @staff.Action getStaffList;
  @purchase.Action purchaseComplete;
  @finance.Action queryPurchaseBillList;
  @supplier.Action getSupplierList;
  @finance.Action createPurchaseBillInvoice;
  @finance.Action createPurchaseBillSettlement;
  @purchase.Mutation setPaymentBtnLoading;
  @purchase.Mutation setMakeInvoiceBtnLoading;
  emptyToLine = emptyToLine;
  splitThousands = splitThousands;
  showViewer: boolean = false;
  orderList: any[] = [];
  searchForm = {
    purchaseNo: "",
    supplierCode: "",
    purchaseStatus: "",
    settlementStatus: "",
    purchaseDateBegin: "",
    purchaseDateEnd: ""
  };
  showComfirmPayment: boolean = false;
  showRegisterInvoice: boolean = false;
  handlePaymentConfirmClick(data) {
    let params = {
      billNo: this.willUpdateRow.billNo,
      paidMethod: data.paidMethod
    };
    this.setPaymentBtnLoading(true);
    this.createPurchaseBillSettlement(params)
      .then(() => {
        this.$message.success(t("base.payment-success") as string);
        this.showComfirmPayment = false;
        this.loadListData();
      })
      .finally(() => {
        this.setPaymentBtnLoading(false);
      });
  }
  imgUrl: any = "";
  closeViewer() {
    this.showViewer = false;
  }
  handleViewInvoice(row) {
    this.imgUrl = row.invoiceUrl;
    this.showViewer = true;
  }
  handleInvoiceConfirmClick(data) {
    this.setMakeInvoiceBtnLoading(true);
    this.createPurchaseBillInvoice(
      Object.assign(data, {
        billNo: data.orderNo
      })
    )
      .then(() => {
        this.$message.success(t("purchase.invoice-register-success") as string);
        this.showRegisterInvoice = false;
        this.loadListData();
      })
      .finally(() => {
        this.setMakeInvoiceBtnLoading(false);
      });
  }
  handleComfirmCommand(command) {
    switch (command) {
      case "payment":
        this.showComfirmPayment = true;
        break;
      case "invoice":
        this.showRegisterInvoice = true;
        break;
    }
  }
  created() {
    this.init();
    this.loadListData();
  }
  settlementList: any = [];
  invoiceStatusList: any = [];
  init() {
    // 获取供应商
    this.searchSupplier();
    // 结算方式字典List
    this.getDictionaryList("purchase_settlement_status").then(data => {
      this.settlementList = data;
    });
    // 开票状态字典List
    this.getDictionaryList("invoice_status").then(data => {
      this.invoiceStatusList = data;
    });
  }
  @Table.LoadDataMethod()
  loadListData() {
    return this.queryPurchaseBillList({
      ...this.searchForm,
      orderItems: this.mix_sortParams,
      pageNum: this.mix_pageNum,
      pageSize: this.mix_pageSize
    }).then(data => {
      this.orderList = data.data.list;
      return data;
    });
  }
  handleSwitchStatus() {
    this.mix_pageNum = 1;
    this.loadListData();
  }
  get searchList() {
    return [
      {
        label: t("finance.statement-number"),
        type: "input",
        value: "",
        prop: "billNo"
      },
      {
        label: t("supplier.name"),
        type: "select-search",
        value: "",
        prop: "supplierCode",
        placeholder: t("v210831.enter-supplier-keyword"),
        selectList: this.supplierList,
        searchFun: this.searchSupplier
      },
      {
        label: t("base.settlement-status"),
        type: "select",
        selectList: this.settlementList,
        value: "",
        prop: "settlementStatus"
      },
      {
        label: t("base.make-invoice-status"),
        type: "select",
        selectList: this.invoiceStatusList,
        value: "",
        prop: "invoiceStatus"
      },
      {
        label: t("finance.creation-time"),
        type: "daterange",
        value: "",
        prop: "billTime"
      }
    ];
  }
  handleSearch(data) {
    this.mix_pageNum = 1;
    data.forEach(item => {
      if (item.prop) {
        if (item.prop === "billTime") {
          this.searchForm["billTimeFrom"] = item.value?.[0] || "";
          this.searchForm["billTimeTo"] = item.value?.[1] || "";
        } else {
          this.searchForm[item.prop] = item.value;
        }
      }
    });
    this.loadListData();
  }
  supplierList: any = [];
  searchSupplier(val = "") {
    this.getSupplierList({
      pageNum: 1,
      pageSize: 10,
      supplierName: val
    }).then(data => {
      this.supplierList = this.$safeValue(data, "data.list", []).map(item => {
        item.label = item.supplierName;
        item.value = item.supplierCode;
        return item;
      });
    });
  }
  willUpdateRow: any = {};
  handleSetCurrentRow(visible, row) {
    if (visible) {
      this.willUpdateRow = Object.assign(row, {
        purchaseAmount: row.billAmount,
        purchaseNo: row.billNo
      });
    }
  }
  handleEdit(row) {
    this.$router.push(`/finance/purchase-settlement-bill/edit/${row.billNo}`);
  }
  handleLinkOrderView(row) {
    let { href } = this.$router.resolve({
      path: `/service/view/${row.orderNo}`
    });
    window.open(href, "_blank");
  }
  handleView(row) {
    let { href } = this.$router.resolve({
      path: `/finance/purchase-settlement-bill/view/${row.billNo}`
    });
    window.open(href, "_blank");
  }
}
